import styles from './AIResponseLog.module.scss'

const CLASS_BY_STATUS = {
  ok: styles.statusOk,
  needs_review: styles.statusReview,
  error: styles.statusError,
}

/**
 * @param {{ status?: 'ok' | 'needs_review' | 'error', label?: string }} props
 */
export default function ResponseStatusBadge({ status = 'ok', label }) {
  const text = label ?? status
  const className = CLASS_BY_STATUS[status] ?? styles.statusOk
  return <span className={`${styles.statusBadge} ${className}`}>{text}</span>
}
